'use strict';
var QuickOrderController = /** @class */ (function () {
    /*@ngInject*/
    function QuickOrderController(Auth, $state, $scope, $element, $timeout, $location, $log, $filter, CartService, RxCredentialListService, ProductService, TypeaheadService, QuickOrderService, CommonDataService) {
        this.addSuccess = false;
        this.probidden = false;
        this.itemCode = '';
        this.totalStock = 0;
        this.showAlert = true;
        this.rxProduct = false;
        this.productDetail = {};
        this.errors = {};
        this.isLoading = false;
        this.validateCode = true;
        this.isRestricted = false;
        this.restrictedMessage = "";
        this.itemdetail = null;
        this.warningMessage = "";
        this.isHeatSensitive = false;
        this.isShortShelfLife = false;
        this.isSpecialOrder = false;
        this.isBackOrder = false;
        this.isDiscontinuedItem = false;
        this.availableStock = 0;
        this.outOfStock = false;
        this.isVendorBackOrder = false;
        this.itemdInventory = {};
        this.showMsg = true;
        this.itemAddErrors = [];
        this.isQuantityExceeds = false;
        this.uiRouterState = $state.current.name;
        var self = this;
        self.$filter = $filter;
        self.$timeout = $timeout;
        self.$element = $element;
        self.$log = $log;
        self.$filter = $filter;
        self.RxCredentialListService = RxCredentialListService;
        self.ProductService = ProductService;
        self.CartService = CartService;
        self.TypeaheadService = TypeaheadService;
        self.QuickOrderService = QuickOrderService;
        this.CommonDataService = CommonDataService;
        var date = new Date();
        this.currentDate = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + 'T' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        self.RxCredentialListService.getRxCredentials()
            .then(function (response) {
            console.log('getRxCredentials response', response);
            self.rxCredentials = response;
        }, function (response) {
            this.$log.error('getRxCredentials error response is...', response);
        });
        //console.log('ele :' , $element);
        //console.log('ele :' , $element[0].querySelector('#focus-prod-item'));
    }
    QuickOrderController.prototype.isRxProduct = function (itemCode) {
        var _this = this;
        if (!itemCode) {
            this.rxProduct = false;
            this.itemDetail = null;
            this.showMsg = false;
            this.productQuantity = '';
            this.clearMessages();
            return;
        }
        this.clearMessages();
        this.productQuantity = '';
        this.showMsg = true;
        this.addSuccess = false;
        this.probidden = false;
        this.itemDetail = null;
        this.warningMessage = '';
        this.restrictedMessage = '';
        this.isRestricted = false;
        this.validateCode = true;
        this.isLoading = true;
        this.itemAddErrors = [];
        this.QuickOrderService.getItemDetail(itemCode)
            .then(function (response) {
            console.log('response in QuickOrderController', response);
            _this.itemDetail = response;
            return response.productId;
        })
            .then(function (productId) {
            return _this.ProductService.getProductDetails(productId);
        })
            .then(function (response) {
            _this.productDetail = response;
            _this.CommonDataService.addAttributeProductPathsForSingleItem(_this.productDetail);
            _this.rxProduct = response.prescriptionOnly;
            var item = _this.$filter('filter')(response.items, { itemCode: _this.itemCode })[0];
            _this.isRestricted = item && item.isRestricted;
            _this.restrictedMessage = item.restrictedMessage ? item.restrictedMessage : 'Purchase Not Authorized';
            _this.restrictionCode = item.restrictionCode;
            _this.isHeatSensitive = response.isHeatSensitive;
            _this.isSpecialOrder = item.specialOrder;
            _this.isDiscontinuedItem = item.isDiscontinued;
            item.inventory.forEach(function (data) {
                if (data.isDefault) {
                    _this.itemInventory = data;
                    _this.isBackOrder = data.backOrder;
                    _this.isShortShelfLife = data.shortShelfLife;
                    _this.availableStock = data.stock;
                    _this.isVendorBackOrder = data.vendorBackOrder;
                    if (_this.availableStock <= 0) {
                        _this.outOfStock = true;
                    }
                }
            });
        })
            .catch(function () {
            _this.validateCode = false;
        })
            .finally(function () {
            _this.isLoading = false;
        });
    };
    QuickOrderController.prototype.isRxCredential = function () {
        console.log('checking isRxCredential', this.rxCredentials);
        return this.rxCredentials == "Prescribe and Dispense" || this.rxCredentials == "Prescribe Only";
    };
    QuickOrderController.prototype.bannerMessage = function (message) {
        console.log('got message');
        this.errors.pageErrorType = 'warning';
        this.errors.pageErrors = message;
        this.errors.havePageErrors = true;
        this.showAlert = true;
    };
    QuickOrderController.prototype.addCart = function (itemCode, quantity) {
        var _this = this;
        console.log('this.isRxCredential()', this.isRxCredential());
        console.log('this.rxProduct', this.rxProduct);
        this.showAlert = false;
        this.addError = false;
        if (((this.itemDetail && this.rxProduct && this.isRxCredential()) || (this.itemDetail && !this.rxProduct)) && !this.isRestricted) {
            console.log('add cart', itemCode, quantity);
            console.log('item id', this.itemCode);
            this.isLoading = true;
            this.CartService.addItemQuantity(itemCode, quantity)
                .then(function (response) {
                _this.addSuccess = true;
                if (response.errors) {
                    _this.itemAddErrors = response.errors;
                }
                _this.$timeout(function () {
                    _this.$element[0].querySelector('#focus-prod-item').focus();
                });
                _this.itemCode = '';
                _this.productQuantity = '';
                _this.itemDetail = null;
                _this.clearMessages();
            })
                .catch(function () { return _this.addError = true; })
                .finally(function () { return _this.isLoading = false; });
        }
        else {
            this.probidden = true;
            console.log('probidden');
        }
    };
    QuickOrderController.prototype.clearMessages = function () {
        this.isHeatSensitive = false;
        this.isSpecialOrder = false;
        this.isDiscontinuedItem = false;
        this.isShortShelfLife = false;
        this.isBackOrder = false;
        this.isVendorBackOrder = false;
        this.outOfStock = false;
        this.isQuantityExceeds = false;
        this.availableStock = 0;
    };
    QuickOrderController.prototype.checkAvailableQuantity = function (quantity) {
        var self = this;
        self.isQuantityExceeds = false;
        if (!self.outOfStock && self.itemDetail && self.itemInventory && quantity > self.availableStock) {
            self.isQuantityExceeds = true;
        }
    };
    return QuickOrderController;
}());
export default QuickOrderController;
//# sourceMappingURL=quick-order.controller.js.map